import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'react-router-redux';
import classNames from 'classnames';

// Utils
import { usePerformHapticFeedback, HapticsStyle } from '../../../../utils/haptics/usePerformHapticFeedback';
import { sendAmplitudeEvent } from '../../../../analytics/amplitudeServiceJS';

// Selectors
import { selectHasRedo, selectHasUndo } from '../../../../utils/undoRedo/undoRedoSelector';

// Actions
import { openSheet } from '../../../structural/sheet/sheetActions';
import { intercomShowMessages } from '../../../../analytics/analyticsActions';
import { redoAction, undoAction } from '../../../../utils/undoRedo/undoRedoActions';

// Components
import Icon from '../../../../components/icons/Icon';
import Button from '../../../../components/buttons/Button';
import MobileNotificationsUtil from './MobileNotificationsUtil';
import MobileSearchTool from '../../tools/searchTool/MobileSearchTool';

// Types
import { SheetId } from '../../../structural/sheet/sheetTypes';
import { EVENT_TYPE_NAMES } from '../../../../../common/analytics/amplitudeEventTypesUtil';

import './MobileUtilsToolList.scss';

const MobileUtilsToolList = () => {
    const hasUndo = useSelector(selectHasUndo);
    const hasRedo = useSelector(selectHasRedo);

    const performHapticFeedback = usePerformHapticFeedback();

    const dispatch = useDispatch();

    const dispatchOpenMobileNotificationsSheet = () => dispatch(openSheet(SheetId.Notifications));
    const dispatchUndoAction = () => {
        performHapticFeedback(HapticsStyle.ImpactLight);

        dispatch(undoAction());

        sendAmplitudeEvent({
            eventType: EVENT_TYPE_NAMES.CLICKED_UNDO_BUTTON,
        });
    };
    const dispatchRedoAction = () => {
        performHapticFeedback(HapticsStyle.ImpactLight);

        dispatch(redoAction());

        sendAmplitudeEvent({
            eventType: EVENT_TYPE_NAMES.CLICKED_REDO_BUTTON,
        });
    };

    return (
        <div className="MobileUtilsToolList">
            <div className="tools">
                <Button
                    className={classNames('mobile-util-button undo-button', { disabled: !hasUndo })}
                    onClick={dispatchUndoAction}
                >
                    <Icon name="mobile-toolbar-undo" />
                    <div className="label">Undo</div>
                </Button>
                <Button
                    className={classNames('mobile-util-button redo-button', { disabled: !hasRedo })}
                    onClick={dispatchRedoAction}
                >
                    <Icon name="mobile-toolbar-redo" />
                    <div className="label">Redo</div>
                </Button>
                <div className="divider" />
                <Button className="mobile-util-button" onClick={() => dispatch(intercomShowMessages())}>
                    <Icon name="mobile-toolbar-support" />
                    <div className="label">Help</div>
                </Button>
                <MobileSearchTool />
                <Button className="mobile-util-button" onClick={dispatchOpenMobileNotificationsSheet}>
                    <MobileNotificationsUtil />
                </Button>
                <Button className="mobile-util-button" onClick={() => dispatch(push('/account'))}>
                    <Icon name="mobile-toolbar-settings" />
                    <div className="label">Settings</div>
                </Button>
            </div>
        </div>
    );
};

export default MobileUtilsToolList;
